// A custom hook that builds on useLocation to parse
// the query string for you.
export const useQueryParam = () => {
  return new URLSearchParams(window.location.search);
};
